/* Página de produto: bolinhas de cor e cópia do código de desconto */
(function () {
  if (window.__lvFarben) return;
  window.__lvFarben = true;

  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('.lv-swatch') : null;
    if (!botao) return;

    var lista = botao.closest('.lv-swatches');
    var select = document.getElementById(lista.dataset.lvSelect);
    if (!select) return;

    select.value = botao.dataset.lvValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    lista.querySelectorAll('.lv-swatch').forEach(function (b) {
      var ativo = b === botao;
      b.classList.toggle('is-selected', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });

    var rotulo = document.getElementById(lista.dataset.lvLabel);
    if (rotulo) rotulo.textContent = botao.dataset.lvValue;
  });
})();

/* Código de desconto: clicar copia para a área de transferência */
(function () {
  if (window.__lvGutschein) return;
  window.__lvGutschein = true;

  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('.lv-coupon__code') : null;
    if (!botao) return;

    var codigo = botao.dataset.lvCode || '';
    var dica = botao.querySelector('.lv-coupon__hint');
    var original = dica ? dica.textContent : '';

    function confirmar() {
      if (!dica) return;
      dica.textContent = botao.dataset.lvDone || 'OK';
      botao.classList.add('is-copied');
      setTimeout(function () {
        dica.textContent = original;
        botao.classList.remove('is-copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(confirmar, function () {});
    } else {
      var campo = document.createElement('textarea');
      campo.value = codigo;
      campo.setAttribute('readonly', '');
      campo.style.position = 'absolute';
      campo.style.left = '-9999px';
      document.body.appendChild(campo);
      campo.select();
      try { document.execCommand('copy'); confirmar(); } catch (err) {}
      document.body.removeChild(campo);
    }
  });
})();

/* Data de entrega estimada: conta dias úteis a partir de hoje. */
(function () {
  var NAMEN = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function tageAddieren(start, tage, modus) {
    var d = new Date(start.getTime());
    if (modus === 'werktage') {
      var rest = tage;
      while (rest > 0) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) rest--;
      }
    } else {
      d.setDate(d.getDate() + tage);
    }
    return d;
  }

  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  function formatieren(d, modus) {
    var tag = zwei(d.getDate());
    var monat = zwei(d.getMonth() + 1);
    if (modus === 'lang') return NAMEN[d.getDay()] + ', ' + tag + '.' + monat + '.';
    return tag + '/' + monat;
  }

  function setzen(el) {
    var ziel = el.querySelector('[data-lv-datum]');
    if (!ziel) return;

    var min = parseInt(el.getAttribute('data-tage-min'), 10);
    var max = parseInt(el.getAttribute('data-tage-max'), 10);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var modus = el.getAttribute('data-format') || 'kurz';
    var zaehlung = el.getAttribute('data-modus') || 'kalender';

    if (isNaN(min) || min < 0) min = 5;
    if (isNaN(max) || max < min) max = min;

    var start = new Date();
    if (!isNaN(cutoff) && cutoff > 0 && start.getHours() >= cutoff) {
      start.setDate(start.getDate() + 1);
    }

    var von = tageAddieren(start, min, zaehlung);
    var bis = tageAddieren(start, max, zaehlung);

    ziel.textContent = min === max
      ? formatieren(von, modus)
      : formatieren(von, modus) + ' – ' + formatieren(bis, modus);
  }

  function starten() {
    var alle = document.querySelectorAll('[data-lv-lieferdatum]');
    for (var i = 0; i < alle.length; i++) setzen(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
  document.addEventListener('shopify:section:load', starten);
})();

/* Barra fixa: surge ao passar da primeira secao e leva ao seletor de pacotes.
   Vai para o body porque um ancestral com transform quebraria o position fixed.
   Neste tema o body e o container de rolagem, por isso os ouvintes ficam em
   window, document e body ao mesmo tempo. */
(function () {
  function iniciar() {
    var leiste = document.querySelector('[data-lv-sticky-cta]');
    if (!leiste || leiste.dataset.lvBereit === '1') return;

    var sektion = document.querySelector('[id^="shopify-section"][id*="main-product"]')
      || document.querySelector('.product__info');
    if (!sektion) return;

    leiste.dataset.lvBereit = '1';
    document.body.appendChild(leiste);

    function ziel() {
      if (leiste.getAttribute('data-ziel') === 'paket') {
        // o seletor casa tambem com tags <script> do app, por isso filtra por altura
        var candidatos = document.querySelectorAll('kaching-bundles, [class*="kaching-bundles"], [data-kaching-bundles]');
        for (var i = 0; i < candidatos.length; i++) {
          var c = candidatos[i];
          if (c.tagName !== 'SCRIPT' && c.getBoundingClientRect().height > 20) return c;
        }
      }
      return sektion.querySelector('button[name="add"]')
        || document.querySelector('button[name="add"]')
        || sektion;
    }

    var btn = leiste.querySelector('[data-lv-sticky-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        var alvo = ziel();
        if (!alvo) return;
        var y = alvo.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    }

    function pruefen() {
      leiste.classList.toggle('ist-sichtbar', sektion.getBoundingClientRect().bottom < 0);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(pruefen, { threshold: 0 }).observe(sektion);
    }

    ['scroll', 'touchmove', 'wheel'].forEach(function (ev) {
      [window, document, document.body].forEach(function (alvo) {
        alvo.addEventListener(ev, pruefen, { passive: true });
      });
    });

    window.addEventListener('resize', pruefen, { passive: true });
    window.addEventListener('load', pruefen);
    pruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();

/* Faixa de cores dentro de cada barra do Kaching Bundles. */
(function () {
  function lesen(quelle, chave) {
    var bruto = quelle.getAttribute(chave) || '';
    return bruto.split('\n').map(function (linha) {
      var t = linha.trim();
      if (!t) return null;
      var corte = t.lastIndexOf(':');
      if (corte < 0) return { label: t, hex: 'transparent' };
      return { label: t.slice(0, corte).trim(), hex: t.slice(corte + 1).trim() };
    }).filter(Boolean);
  }

  function zeichnen(liste, punkt) {
    var faixa = document.createElement('div');
    faixa.className = 'lv-paket-farben';
    faixa.setAttribute('data-lv-pf', '1');
    faixa.style.setProperty('--lv-pf-punkt', punkt + 'px');
    liste.forEach(function (c) {
      var item = document.createElement('span');
      item.className = 'lv-paket-farben__item';
      var ponto = document.createElement('span');
      ponto.className = 'lv-paket-farben__punkt';
      ponto.style.background = c.hex;
      var txt = document.createElement('span');
      txt.textContent = c.label;
      item.appendChild(ponto);
      item.appendChild(txt);
      faixa.appendChild(item);
    });
    return faixa;
  }

  function anwenden() {
    var quelle = document.querySelector('[data-lv-paket-farben]');
    if (!quelle) return;
    var barras = document.querySelectorAll('.kaching-bundles__bar');
    if (!barras.length) return;

    var punkt = parseInt(quelle.getAttribute('data-punkt'), 10) || 11;
    var dados = [lesen(quelle, 'data-p1'), lesen(quelle, 'data-p2'), lesen(quelle, 'data-p3')];

    for (var i = 0; i < barras.length; i++) {
      var liste = dados[i];
      var antiga = barras[i].querySelector('[data-lv-pf]');
      if (!liste || !liste.length) { if (antiga) antiga.remove(); continue; }
      if (antiga) {
        if (antiga.getAttribute('data-assinatura') === JSON.stringify(liste)) continue;
        antiga.remove();
      }
      var faixa = zeichnen(liste, punkt);
      faixa.setAttribute('data-assinatura', JSON.stringify(liste));
      barras[i].classList.add('lv-hat-farben');
      barras[i].appendChild(faixa);
    }
  }

  function iniciar() {
    anwenden();
    // o Kaching redesenha as barras ao trocar de variante
    var alvo = document.querySelector('.kaching-bundles') || document.body;
    new MutationObserver(function () {
      clearTimeout(window.__lvPfTimer);
      window.__lvPfTimer = setTimeout(anwenden, 60);
    }).observe(alvo, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

/* Cartões de kit: substituem o seletor de uma opção de variante. */
(function () {
  function geld(centavos) {
    return (centavos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function farbenLesen(bruto) {
    return String(bruto || '').split('\n').map(function (linha) {
      var t = linha.trim();
      if (!t) return null;
      var corte = t.lastIndexOf(':');
      if (corte < 0) return { label: t, hex: 'transparent' };
      return { label: t.slice(0, corte).trim(), hex: t.slice(corte + 1).trim() };
    }).filter(Boolean);
  }

  // o tema usa <select> no modo dropdown e radio no modo botão
  function steuerung(feld) {
    var sel = feld.querySelector('select');
    if (sel) {
      return {
        werte: [].slice.call(sel.options).map(function (o) { return o.value; }),
        lesen: function () { return sel.value; },
        setzen: function (v) {
          sel.value = v;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
    }
    var radios = [].slice.call(feld.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return null;
    return {
      werte: radios.map(function (r) { return r.value; }),
      lesen: function () {
        for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
        return undefined;
      },
      setzen: function (v) {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value !== v) continue;
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    };
  }

  function iniciar() {
    var wurzel = document.querySelector('[data-lv-kits]');
    if (!wurzel) return;

    var slug = wurzel.getAttribute('data-option') || 'paket';
    var feld = document.querySelector('[data-option-slug="' + slug + '"]');
    if (!feld) return;

    var ctrl = steuerung(feld);
    if (!ctrl) return;

    var idx = parseInt((feld.getAttribute('data-option-index') || '').replace('option', ''), 10);
    if (!isFinite(idx) || idx < 1) return;

    var dados = document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
    var variantes = [];
    try { variantes = JSON.parse(dados.textContent); } catch (e) { return; }

    feld.classList.add('lv-option-versteckt');

    var badges = [wurzel.getAttribute('data-b1'), wurzel.getAttribute('data-b2'), wurzel.getAttribute('data-b3')];
    var cores = [
      farbenLesen(wurzel.getAttribute('data-f1')),
      farbenLesen(wurzel.getAttribute('data-f2')),
      farbenLesen(wurzel.getAttribute('data-f3'))
    ];

    function andereWerte() {
      var mapa = {};
      document.querySelectorAll('[data-option-index]').forEach(function (el) {
        var n = parseInt((el.getAttribute('data-option-index') || '').replace('option', ''), 10);
        if (!isFinite(n)) return;
        var c = steuerung(el);
        if (c) mapa[n] = c.lesen();
      });
      return mapa;
    }

    function variantFuer(wert) {
      var mapa = andereWerte();
      mapa[idx] = wert;
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], ok = true;
        for (var n in mapa) {
          if (mapa[n] === undefined) continue;
          if (v['option' + n] !== mapa[n]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function zeichnen() {
      var atual = ctrl.lesen();
      wurzel.textContent = '';

      ctrl.werte.forEach(function (wert, n) {
        var v = variantFuer(wert);
        var karte = document.createElement('button');
        karte.type = 'button';
        karte.className = 'lv-kit' + (atual === wert ? ' ist-gewaehlt' : '');
        karte.setAttribute('aria-pressed', atual === wert ? 'true' : 'false');

        if (badges[n]) {
          var badge = document.createElement('span');
          badge.className = 'lv-kit__badge';
          badge.textContent = badges[n];
          karte.appendChild(badge);
        }

        var kopf = document.createElement('span');
        kopf.className = 'lv-kit__kopf';

        var radio = document.createElement('span');
        radio.className = 'lv-kit__radio';
        kopf.appendChild(radio);

        var titel = document.createElement('span');
        titel.className = 'lv-kit__titel';
        titel.textContent = wert;
        kopf.appendChild(titel);

        var preise = document.createElement('span');
        preise.className = 'lv-kit__preise';
        if (v) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var alt = document.createElement('span');
            alt.className = 'lv-kit__alt';
            alt.textContent = geld(v.compare_at_price);
            preise.appendChild(alt);
          }
          var neu = document.createElement('span');
          neu.className = 'lv-kit__neu';
          neu.textContent = geld(v.price);
          preise.appendChild(neu);
        }
        kopf.appendChild(preise);
        karte.appendChild(kopf);

        if (cores[n] && cores[n].length) {
          var faixa = document.createElement('span');
          faixa.className = 'lv-kit__farben';
          cores[n].forEach(function (c) {
            var item = document.createElement('span');
            item.className = 'lv-kit__farbe';
            var ponto = document.createElement('span');
            ponto.className = 'lv-kit__punkt';
            ponto.style.background = c.hex;
            var txt = document.createElement('span');
            txt.textContent = c.label;
            item.appendChild(ponto);
            item.appendChild(txt);
            faixa.appendChild(item);
          });
          karte.appendChild(faixa);
        }

        karte.addEventListener('click', function () {
          if (ctrl.lesen() === wert) return;
          ctrl.setzen(wert);
          setTimeout(zeichnen, 30);
        });

        wurzel.appendChild(karte);
      });
    }

    zeichnen();

    // redesenha quando o tamanho muda
    document.querySelectorAll('[data-option-index]').forEach(function (el) {
      if (el === feld) return;
      el.addEventListener('change', function () { setTimeout(zeichnen, 40); });
      el.addEventListener('click', function () { setTimeout(zeichnen, 80); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

/* ----------------------------------------------------------------
   Troca a foto grande conforme o pacote escolhido no Kaching Bundles.

   O app redesenha as barras sozinho e já trocou de versão uma vez, então
   a ligação é feita por delegação de clique e pelo TEXTO da barra
   ("3ER-PACK" / "5ER-PACK"), nunca por classe CSS — assim não quebra
   quando o Kaching atualiza.

   O mapeamento foi conferido olhando as imagens, não pelo texto alternativo:
   a de 4 peças é o pacote 3+1, a de 7 peças é o 5+2.
   ---------------------------------------------------------------- */
(function () {
  var MIDIA_4_PECAS = '46496011944152'; // Boxhero_Boxer_Briefs_in_Neutral_Studio_Light
  var MIDIA_7_PECAS = '46480986603736'; // BOXHERO_Boxer_Brief_Collection

  function mostrarMidia(id) {
    var galeria = document.querySelector('media-gallery');
    if (!galeria) return false;
    var alvo = galeria.querySelector('[data-media-id="' + id + '"]');
    if (!alvo) return false;

    if (typeof galeria.setActiveMedia === 'function') {
      try {
        galeria.setActiveMedia(id, false);
        return true;
      } catch (e) {
        /* cai no scroll abaixo */
      }
    }
    alvo.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    return true;
  }

  // Sobe a partir do elemento clicado até achar um bloco que contenha
  // exatamente UM dos dois pacotes. Se os dois aparecerem, subiu demais.
  function midiaDoClique(elemento) {
    for (var n = elemento, i = 0; n && i < 6; n = n.parentElement, i++) {
      var texto = n.textContent || '';
      if (texto.length > 400) break;
      var cinco = /5\s*ER[\s-]*PACK/i.test(texto);
      var tres = /3\s*ER[\s-]*PACK/i.test(texto);
      if (cinco !== tres) return cinco ? MIDIA_7_PECAS : MIDIA_4_PECAS;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (evento) {
      var id = midiaDoClique(evento.target);
      if (!id) return;
      // o Kaching redesenha a barra logo após o clique; deixa o DOM assentar
      setTimeout(function () { mostrarMidia(id); }, 150);
    },
    true
  );
})();
